// extracted by mini-css-extract-plugin
export default {"cls1":"jap46HkZaYnWBe6RvjHU","cls2":"ne2z62Qs19QPcRrWd4p9 jap46HkZaYnWBe6RvjHU","bookingAppRedesign":"N_7w8oTd8S3o_Q_8kXaA"};